import { Effect, EffectProperties, EffectFields } from '../../core/Effect';
import * as PostProcessing from '@react-three/postprocessing';
import { forwardRef } from 'react';
import * as THREE from 'three';
import { Field } from '@/types/core/Field';

export interface PixelationEffectProperties extends EffectProperties {
  granularity: number;
}

// Create a reusable Pixelation component that can be used in both preview and world
const PixelationComponent = forwardRef<any, { properties: PixelationEffectProperties; isPreview?: boolean }>((props, ref) => {
  const { properties, isPreview } = props;

  if (isPreview) {
    return null;
  }
  
  const { granularity } = properties;

  return (
    <PostProcessing.Pixelation
      ref={ref}
      granularity={granularity}
    />
  );
});

export const PixelationEffectItem: Effect<PixelationEffectProperties> = {
  id: '',
  name: 'Pixelation',
  type: 'effect',
  subtype: 'Pixelation',
  icon: 'Effect',
  properties: {
    granularity: 5,
  },
  fields: [
    ...EffectFields,
    {
      key: 'properties.granularity',
      type: 'number',
      label: 'Granularity',
      default: 5,
      min: 1,
      max: 30,
      step: 1,
      panel: 'effect',
    }
  ],
  render: (properties: PixelationEffectProperties, isPreview: boolean, ref: React.RefObject<THREE.Object3D | null>) => {
    return <PixelationComponent properties={properties} isPreview={isPreview} ref={ref as any} />;
  }
};